import {API_DRIVER} from "../configs/axios";

const ContrattoDigitaleService = {
    getDigitalContracts: (integrationId) => {
        return API_DRIVER.get(`/api/contratto-digitale/digital-contracts-list/customer/${integrationId}`)
    },
    getContractDetails: (integrationId, idTrattativa) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-offer-summary-header/customer/${integrationId}/digital-contract/${idTrattativa}`)
    },
    getContractTables: (integrationId, idTrattativa) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-offer-summary/customer/${integrationId}/digital-contract/${idTrattativa}`)
    },
    getDeviceTable: (integrationId, idTrattativa) => {
        return API_DRIVER.get(`/api/contratto-digitale/device/customer/${integrationId}/digital-contract/${idTrattativa}`)
    },
    getDeviceDetailsConsegne: (integrationId, idTrattativa, deviceCommercialLabel) => {
        return API_DRIVER.get(`/api/contratto-digitale/device/details/customer/${integrationId}/consegne`, {
            params: {
                idTrattativa,
                deviceCommercialLabel,
            }
        })
    },
    getDeviceDetailsConsegnati: (integrationId, deviceCommercialLabel, orderId) => {
        return API_DRIVER.get(`/api/contratto-digitale/device/details/customer/${integrationId}/consegnati`, {
            params: {
                deviceCommercialLabel,
                orderId
            }
        })
    },
    getSimsAssociatedToPlan: (integrationId, serviceType, commercialLabel, profilo, page, rowsPerPage, sort, msisdn, iccId, tags, piano) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-sims-associated-to-plan/customer/${integrationId}/service-type/${serviceType}/commercial-label/${commercialLabel}/profilo/${profilo}`,
            {
                params: {
                    page,
                    size: rowsPerPage,
                    sort,
                    msisdn,
                    iccId,
                    tags,
                    piano
                }
            })
    },
    getSimsAssociatedToPlanFilterData: (companyId) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-sims-associated-to-plan/filter-data`,
            {
                params: {
                    companyId
                }
            })
    },
    getSimsAssociatedToOption: (integrationId, commercialLabel, page, rowsPerPage, sort, msisdn, iccId, tags, piano) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-sims-associated-to-option/customer/${integrationId}/commercial-label/${commercialLabel}`,
            {
                params: {
                    page,
                    size: rowsPerPage,
                    sort,
                    msisdn,
                    iccId,
                    tags,
                    piano,
                }
            })
    },
    getSimsAssociatedToOptionFilterData: (companyId) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-sims-associated-to-option/filter-data`,
            {
                params: {
                    companyId
                }
            })
    },
    getSimsNotAssociatedToOption: (integrationId, commercialLabel, page, rowsPerPage, sort, msisdn, iccId, tags, piano) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-sims-not-associated-to-option/customer/${integrationId}/commercial-label/${commercialLabel}`,
            {
                params: {
                    page,
                    size: rowsPerPage,
                    sort,
                    msisdn,
                    iccId,
                    tags,
                    piano
                }
            })
    },
    getSimsNotAssociatedToOptionFilterData: (companyId) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-sims-not-associated-to-option/filter-data`,
            {
                params: {
                    companyId
                }
            })
    },
    getSuitableSimList: (integrationId, commercialLabel) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-offer-suitable-list-sims/customer/${integrationId}/commercial-label/${commercialLabel}`)
    },
    fetchCurrentPlan: (commercialLabel, idTrattativa, integrationId) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-options-for-plan/customer/${integrationId}/trattativa/${idTrattativa}/commercial-label/${commercialLabel}`)
    },
    fetchCurrenPlafondShare: (commercialLabel, idTrattativa, integrationId) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-plafond-share-plan-details/customer/${integrationId}/trattativa/${idTrattativa}/commercial-label/${commercialLabel}`)
    },
    fetchPlafondShareAssociatedSims: (integrationId, serviceType, commercialLabel, profilo, page, size, sort, msisdn, iccId, tags, piano) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-sims-associated-to-plafond-share/customer/${integrationId}/service-type/${serviceType}/commercial-label/${commercialLabel}/profilo/${profilo}`, {
            params: {
                page,
                size,
                sort,
                msisdn,
                iccId,
                tags,
                piano
            }
        })
    },
    fetchCurrentOpzioniPlan: (integrationId, idTrattativa, commercialLabel, slug) => {
        return API_DRIVER.get(`/api/contratto-digitale/get-option-details/customer/${integrationId}/trattativa/${idTrattativa}/commercial-label/${commercialLabel}/slug/${slug}`)
    },
    fetchServiceLists: (integrationId, idTrattativa) => {
        return API_DRIVER.get(`/api/contratto-digitale/servizi-aggiuntivi/services-included/customer/${integrationId}/digital-contract/${idTrattativa}`)
    },
    fetchServiceDetails: (integrationId, apnName, apnType) => {
        return API_DRIVER.get(`/api/contratto-digitale/servizi-aggiuntivi/customer/${integrationId}/apn-name/${apnName}/apn-type/${apnType}`)
    },
    fetchCollaboratorsForSimFilter: (integrationId) => {
        return API_DRIVER.get(`/api/contratto-digitale/sim-collaborators/integrationId/${integrationId}`)
    },
    fetchApnLists: (integrationId, idTrattativa) => {
        return API_DRIVER.get(`/api/contratto-digitale/servizi-aggiuntivi/customer/${integrationId}/digital-contract/${idTrattativa}`)
    },
    fetchApnSims: (integrationId, page, size, sortBy, sortOrder, iccid, msisdn, tipoApn, nomeApn, tags) => {
        return API_DRIVER.get(`/api/contratto-digitale/servizi-aggiuntivi/sim-apn`, {
            params: {
                integrationId,
                page,
                size,
                sortBy,
                sortOrder,
                iccid,
                msisdn,
                tipoApn,
                nomeApn,
                tags
            }
        })
    },
    fetchApnSimsFilterData: (companyId) => {
        return API_DRIVER.get(`/api/contratto-digitale/servizi-aggiuntivi/sim-apn/filter-data`, {
            params: {
                companyId
            }
        })
    },
    fetchExtraShareList: (integrationId) => {
        return API_DRIVER.get(`/api/contratto-digitale/extra-share-list/${integrationId}`)
    }
}

export default ContrattoDigitaleService;
